import type { CourseCertificateUploadError } from "../models/courseCertificate";
import { getErrorCodeMessage } from "../utils/errorCodeMessages";

type CourseCertificateUploadErrorsProps = {
  errors: CourseCertificateUploadError[];
  title?: string;
};

const DEFAULT_TITLE = "Nogle filer kunne ikke uploades";

const CourseCertificateUploadErrors = ({
  errors,
  title = DEFAULT_TITLE,
}: CourseCertificateUploadErrorsProps) => {
  if (errors.length === 0) {
    return null;
  }

  return (
    <div className="d-flex flex-column gap-2 w-100 min-w-0">
      <p className="mb-0 small fw-semibold">{title}</p>

      <ul
        className="list-unstyled mb-0 d-flex flex-column gap-2"
        style={{ maxHeight: "10rem", overflowY: "auto" }}
      >
        {errors.map((error) => (
          <li
            key={error.id}
            className="rounded-2 px-2 py-2"
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.55)",
              border: "1px solid rgba(146, 64, 14, 0.15)",
            }}
          >
            <p
              className="mb-1 small fw-semibold text-truncate"
              title={error.fileName}
            >
              {error.fileName}
            </p>
            <p className="mb-0 small opacity-75">
              {getErrorCodeMessage(error.errorCode)}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CourseCertificateUploadErrors;
